import { identity } from 'lodash';
import { createDeepSelector } from '../../../../utils/milanoteReselect/milanoteReselect';
import { AutoCellTypeObject, CellSelections, CellTypeObject } from '../../../../../common/table/TableTypes';
import { ActiveTableSelector } from '../hotTableStoreHooks';
import { ActiveTableObject } from '../hotTableStoreTypes';
import { getHotTableCellBackgroundColor } from '../../utils/hotInstanceUtils/hotTableCellMetaUtils';
import { getAllCellsBetween } from '../../utils/tableCellSelectionUtils';
import { getSharedFormattingValuesFromHot } from '../../utils/tableCellTypeUtils';

type SharedFormattingValues = Partial<CellTypeObject> | AutoCellTypeObject | undefined;

export const selectActiveTableCellSelection: ActiveTableSelector<CellSelections | undefined> = createDeepSelector<
    ActiveTableObject | undefined,
    unknown,
    CellSelections | undefined
>(
    // It's important that we get the selection state here, rather than in the return function, otherwise
    //  if we just pass through the activeTableState, the selector will not re-run, because the table instance reference
    //  is stable.
    (activeTableState) => activeTableState?.instance?.getSelected(),
    identity,
);

/**
 * Get the background colour of the current cell selection.
 */
export const selectActiveTableCurrentCellBackgroundColor: ActiveTableSelector<string | null | undefined> = (
    activeTable,
) => {
    if (!activeTable?.instance) return null;
    const currentSelection = selectActiveTableCellSelection(activeTable);
    return getHotTableCellBackgroundColor(activeTable.instance, currentSelection);
};

/**
 * Returns the shared cell type formatting values for the active selection using live HoT cell metadata.
 */
export const selectActiveTableSharedFormattingValues: ActiveTableSelector<SharedFormattingValues> = createDeepSelector<
    ActiveTableObject | undefined,
    CellSelections | undefined,
    ActiveTableObject | undefined,
    SharedFormattingValues | undefined
>(selectActiveTableCellSelection, identity, (currentSelection, activeTableState) => {
    if (!activeTableState || !currentSelection?.length) return;

    return getSharedFormattingValuesFromHot(activeTableState.instance, getAllCellsBetween(currentSelection));
});
